import { http } from '../client';
import type { CallOptions, WriteOptions } from '../types';
import type { WebhooksApi } from './webhooks';

// Paths mirror subsystems/communications/facade/adapters/admin-api/src/admin/webhooks.rs.
const seg = encodeURIComponent;
const rd = (o?: CallOptions) => ({ signal: o?.signal });
const wr = (o?: WriteOptions) => ({ signal: o?.signal, idempotencyKey: o?.idempotencyKey, notifyCustomer: o?.notifyCustomer });

export const webhooksHttp: WebhooksApi = {
  listWebhookEndpoints: (owner, opts) => http.get('api', `/webhooks/${seg(owner)}/endpoints`, rd(opts)),
  createWebhookEndpoint: (owner, body, opts) => http.post('api', `/webhooks/${seg(owner)}/endpoints`, body, wr(opts)),
  updateWebhookEndpoint: (owner, id, body, opts) => http.put('api', `/webhooks/${seg(owner)}/endpoints/${seg(id)}`, body, wr(opts)),
  testWebhookEndpoint: (owner, id, opts) => http.post('api', `/webhooks/${seg(owner)}/endpoints/${seg(id)}/test`, {}, wr(opts)),
  listWebhookDeliveries: (owner, query, opts) => http.get('api', `/webhooks/${seg(owner)}/deliveries`, { query: { ...query }, ...rd(opts) }),
  resendWebhookDelivery: (owner, id, opts) => http.post('api', `/webhooks/${seg(owner)}/deliveries/${seg(id)}/resend`, {}, wr(opts)),
};
